const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Draggable = require("react-draggable");
const ModalClose = require("./ModalClose");
const WonkyButton = require("./WonkyButton");
const Sounds = require("../util/Sounds");
const BugCopy = require("../util/CopyTable").forBugReport();
const LoadingCircle = require("./LoadingCircle");
const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");

const styles = require("./styles/BugReportArrow.css");

module.exports = createReactClass({
	displayName: "BugReportArrow",

	propTypes: {
		onClose: PT.func.isRequired,
		onSubmit: PT.func.isRequired,
	},

	getInitialState: function() {
		return {
			dragging: false,
			arrowFacingRight: true,
			isSubmitting: false,
		};
	},

	onArrowDragStart: function() {
		this.setState({
			dragging: true,
		});
	},

	onArrowDrag: function() {
		const rect = this.screenshotDraggable.getBoundingClientRect();
		const limit = rect.width / 10;
		if (this.state.arrowFacingRight && rect.left <= limit) {
			this.setState({
				arrowFacingRight: false,
			});
		} else if (
			!this.state.arrowFacingRight &&
			rect.right >= window.innerWidth - limit
		) {
			this.setState({
				arrowFacingRight: true,
			});
		}
	},

	onArrowDragStop: function() {
		this.setState({
			dragging: false,
		});
	},

	onSubmit: function() {
		Sounds.playSound("button-click");
		this.setState({isSubmitting: true});
		this.props.onSubmit();
	},

	render: function() {
		// Add a class that reflects the arrow.
		let arrowOrientationClass = this.state.arrowFacingRight
			? styles.right
			: styles.left;
		if (this.state.isSubmitting) {
			arrowOrientationClass += " " + styles.submitting;
		}
		return (
			<Portal container={PORTAL_CONTAINERS.BUG_MODAL}>
				<Draggable
					axis="both"
					handle="*"
					bounds={{
						top: -window.innerHeight / 2,
						bottom: window.innerHeight / 2,
						left: -window.innerWidth / 2,
						right: window.innerWidth / 2,
					}}
					grid={[1, 1]}
					cancel=".baNoDrag"
					disabled={this.state.submitting}
					onStart={this.onArrowDragStart}
					onDrag={this.onArrowDrag}
					onStop={this.onArrowDragStop}
				>
					<div
						className={styles.draggable}
						ref={c => (this.screenshotDraggable = c)}
					>
						<div className={arrowOrientationClass}>
							<div className={styles.arrow}>
								<img
									src={
										global.BASE_URL +
										"assets/images/elements/bug-report-arrow.svg"
									}
								/>
							</div>
							<div className={styles.instructions}>
								<div className={styles.drag}>{BugCopy.dragArrow}</div>
								<div className={styles.instrSubmit}>
									<LoadingCircle
										colorType={"red"}
										centerImgSrc={
											global.BASE_URL + "assets/images/icons/button-bug-red.svg"
										}
									/>
								</div>
							</div>
							<div className={styles.submit}>
								<WonkyButton
									handleClick={this.onSubmit}
									buttonType="submit"
									className={styles.blueButton}
								/>
							</div>
							<ModalClose
								extraClassName={styles.close}
								onClick={this.props.onClose}
							/>
						</div>
					</div>
				</Draggable>
			</Portal>
		);
	},
});
